export { default } from './IconFont';
export type { IconFontName } from './IconFontName';
